// extracted by mini-css-extract-plugin
export default {"siteloader":"siteloader_siteloader__9w8iF","main":"siteloader_main__oX+M6","center":"siteloader_center__G0H2F","middle":"siteloader_middle__C7dNe","top":"siteloader_top__a+iua"};